import { get, isFunction } from 'lodash';

import { DMColDef } from '../dm-grid/dm-grid.component';

export const getGridFinalValue = <T = any>(data: T, column: DMColDef) => {
  const path = get(column, 'field', '');

  const valueGetter = get(column, 'valueGetter', '');
  const valueFormatter = get(column, 'valueFormatter', '');

  const value = isFunction(valueGetter)
    ? valueGetter({ data, column } as any)
    : get(data, path, '');

  return {
    field: path,
    cellValue: value,
    formattedValue: isFunction(valueFormatter)
      ? valueFormatter({ value, data } as any)
      : value,
  };
};
